export default __webpack_public_path__ + "static/media/position_ok.f6a3434d.png";